import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/palmares`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les palmares
export const getAllPalmares = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allPalmares`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des palmares:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour récupérer les palmares d'une section
export const getPalmaresBySection = async (section) => {
  try {
    const response = await axios.get(`${apiUrl}/section/${section}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la récupération des palmares:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// POST
// Fonction pour ajouter un palmares
export const addPalmares = async (newPalmares) => {
  try {
    const response = await axios.post(`${apiUrl}/addPalmares`, newPalmares, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout d'un palmares:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// PUT
// Fonction pour modifier un palmares avec son id
export const updatePalmares = async (palmares) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updatePalmares/${palmares.id}`,
      palmares,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status !== 200) throw new Error("Failed to update palmares");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la modification du palmares:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// DELETE
// Fonction pour supprimer un palmares avec son id
export const deletePalmares = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deletePalmares/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to delete palmares");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la suppression du palmares:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};
